import { jsx as _jsx } from "react/jsx-runtime";
import Typography from "../../Typography";
const StatsSeparator = ({ children, className }) => {
    if (children)
        return children;
    return (_jsx("div", { className: className, children: _jsx(Typography, { variant: "input-text", children: "\u2022" }) }));
};
StatsSeparator.displayName = "Stats.StatsSeparator";
export default StatsSeparator;
